<ng-template #errorCampo let-clave="clave">
  <div class="cf-field__error" *ngIf="mensaje(clave) as texto"><mat-icon>error</mat-icon> {{ texto }}</div>
</ng-template>

<ng-template #totalFila let-etiqueta="etiqueta" let-campo="campo" let-valor="valor" let-dinero="dinero">
  <div class="m193-total">
    <span class="m193-total__desc">{{ etiqueta }}</span>
    <div class="m193-celda__control">
      <input class="m193-input m193-input--calc" readonly tabindex="-1" [attr.id]="campo"
        [value]="(valor ?? 0) | number:(dinero ? '1.2-2' : '1.0-0')" />
      <button type="button" class="m193-help" (click)="openOrigen(campo)"
        matTooltip="Ver de dónde sale este importe">?</button>
    </div>
  </div>
</ng-template>

<div class="m193-page">

  <ng-container *ngIf="isLoading">
    <div class="m193-loading">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Cargando datos...</p>
    </div>
  </ng-container>

  <ng-container *ngIf="!isLoading">

    <div class="m193-header">
      <div class="m193-header__icon"><mat-icon>summarize</mat-icon></div>
      <div>
        <h5 class="m193-header__title">Modelo 193</h5>
        <p class="m193-header__sub">Resumen anual de retenciones e ingresos a cuenta del IRPF sobre determinados rendimientos del capital mobiliario y de las retenciones del IS e IRNR sobre determinadas rentas</p>
      </div>
    </div>

    <div class="m193-actions">
      <button mat-stroked-button class="cf-btn" (click)="calcular()">
        <mat-icon>refresh</mat-icon> Calcular
      </button>
      <button mat-stroked-button class="cf-btn" (click)="validate()">
        <mat-icon>search</mat-icon> Validar
      </button>
      <button mat-stroked-button class="cf-btn" (click)="saveDraft()" [disabled]="isSaving">
        <mat-icon>save</mat-icon> Guardar borrador
      </button>
      <button mat-stroked-button class="cf-btn cf-btn--primary" (click)="getFile()">
        <mat-icon>file_download</mat-icon> Descargar fichero
      </button>
      <button mat-stroked-button class="cf-btn" [matMenuTriggerFor]="masAcciones">
        <mat-icon>more_horiz</mat-icon> Más
      </button>
      <mat-menu #masAcciones="matMenu">
        <button mat-menu-item (click)="ficheroImportado.click()">
          <mat-icon>upload_file</mat-icon> Importar fichero
        </button>
        <button mat-menu-item (click)="openHistory()">
          <mat-icon>history</mat-icon> Historial
        </button>
        <button mat-menu-item (click)="marcarPresentada()" [disabled]="!declaracionActual">
          <mat-icon>check_circle</mat-icon> Marcar como presentada
        </button>
        <button mat-menu-item *ngIf="path" (click)="redirectFileTax()">
          <mat-icon>send</mat-icon> Presentar en la sede
        </button>
        <button mat-menu-item (click)="descartarBorrador()" [disabled]="!declaracionActual">
          <mat-icon>restore</mat-icon> Descartar borrador
        </button>
      </mat-menu>
      <input #ficheroImportado type="file" hidden (change)="importFile($event)" />
      <span class="m193-actions__spacer"></span>

      <button mat-stroked-button class="cf-btn" (click)="alternarTodo()">
        <mat-icon>{{ todoCompactado ? 'unfold_more' : 'unfold_less' }}</mat-icon>
        {{ todoCompactado ? 'Expandir todo' : 'Compactar todo' }}
      </button>
    </div>

    <div class="m193-alerts" *ngIf="errores.length || avisosValidacion.length">
      <div class="m193-alert" *ngFor="let item of errores; trackBy: trackByIndex">
        <mat-icon>error_outline</mat-icon>
        <span class="m193-alert__text">{{ item.message }}</span>
        <button type="button" *ngIf="item.key" class="m193-alert__link" (click)="irAlCampo(item)">
          {{ esPerceptor(item) ? 'Ver perceptor' : 'Ir al campo' }}
        </button>
      </div>
      <div class="m193-alert m193-alert--warning" *ngFor="let item of avisosValidacion; trackBy: trackByIndex">
        <mat-icon>warning</mat-icon>
        <span class="m193-alert__text">{{ item.message }}</span>
        <button type="button" *ngIf="item.key" class="m193-alert__link" (click)="irAlCampo(item)">
          {{ esPerceptor(item) ? 'Ver perceptor' : 'Ir al campo' }}
        </button>
      </div>
    </div>

    <div class="m193-layout">

      <aside class="m193-rail">
        <div class="m193-rail__block">
          <label class="m193-rail__label" for="buscador">Buscador de campos</label>
          <div class="m193-rail__buscador">
            <input id="buscador" class="m193-input m193-rail__input" name="buscador" type="text"
              placeholder="NIF" [(ngModel)]="buscadorCampo" (keyup.enter)="irAlCampoBuscado()" />
            <button mat-flat-button class="cf-btn cf-btn--primary" (click)="irAlCampoBuscado()">Ir al campo</button>
          </div>
        </div>

        <div class="m193-rail__block">
          <span class="m193-rail__label">Estado</span>
          <span class="m193-pill m193-pill--{{ varianteDeclaracion }}">{{ estadoDeclaracion }}</span>
          <span class="m193-rail__nota" *ngIf="declaracionActual?.fileName">{{ declaracionActual.fileName }}</span>
        </div>

        <div class="m193-rail__block">
          <span class="m193-rail__label">Secciones</span>
          <button type="button" class="m193-rail__seccion" *ngFor="let seccion of secciones; let i = index"
            [class.m193-rail__seccion--activa]="seccionActiva === seccion.clave" (click)="irALaSeccion(seccion.clave)">
            <span class="m193-rail__seccion-texto">
              <span class="m193-rail__seccion-numero">{{ i + 1 }} -</span>
              {{ seccion.titulo }}
            </span>
            <mat-icon class="m193-rail__seccion-check" *ngIf="confirmada(seccion.clave)">check_circle</mat-icon>
            <span class="m193-rail__seccion-hueco" *ngIf="!confirmada(seccion.clave)"></span>
          </button>
        </div>
      </aside>

      <div class="m193-sections">

        <div class="m193-card" id="region-declarante" [class.m193-card--collapsed]="colapsada('declarante')">
          <div class="m193-card__head" (click)="toggleRegion('declarante')">
            <mat-icon>perm_identity</mat-icon>
            <span class="m193-card__head-label">1 - Declarante</span>
            <mat-icon class="m193-card__check" *ngIf="confirmada('declarante')">check_circle</mat-icon>
            <mat-icon class="m193-card__chevron">{{ colapsada('declarante') ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
          </div>
          <div class="m193-card__body">
            <div class="m193-fields">
              <div class="m193-field m193-field--3 cf-field--required" [class.cf-field--invalid]="!!mensaje('sujetoNIF')">
                <app-ui-input id="sujetoNIF" name="sujetoNIF" [(ngModel)]="data.sujetoNIF"
                  [config]="{ label: 'NIF', maxLength: 9 }"></app-ui-input>
                <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'sujetoNIF' }"></ng-container>
              </div>
              <div class="m193-field m193-field--6 cf-field--required" [class.cf-field--invalid]="!!mensaje('sujetoRazonSocial')">
                <app-ui-input id="sujetoRazonSocial" name="sujetoRazonSocial" [(ngModel)]="data.sujetoRazonSocial"
                  [config]="{ label: 'Apellidos y nombre, razón social o denominación del declarante' }"></app-ui-input>
                <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'sujetoRazonSocial' }"></ng-container>
              </div>
              <div class="m193-field m193-field--3 cf-field--required" [class.cf-field--invalid]="!!mensaje('ejercicio')">
                <app-select id="ejercicio" name="ejercicio" [ngModel]="ejercicioSel"
                  (ngModelChange)="ejercicioSel = $event; cambiarEjercicio()"
                  [config]="{ label: 'Ejercicio', options: ejercicioOptions }"></app-select>
                <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'ejercicio' }"></ng-container>
              </div>
              <div class="m193-field m193-field--4 cf-field--required" [class.cf-field--invalid]="!!mensaje('contactoTelefono')">
                <app-ui-input id="contactoTelefono" name="contactoTelefono" [(ngModel)]="data.contactoTelefono"
                  [config]="{ label: 'Teléfono de contacto', maxLength: 9, inputmode: 'tel' }"></app-ui-input>
                <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'contactoTelefono' }"></ng-container>
              </div>
              <div class="m193-field m193-field--8 cf-field--required" [class.cf-field--invalid]="!!mensaje('contactoNombre')">
                <app-ui-input id="contactoNombre" name="contactoNombre" [(ngModel)]="data.contactoNombre"
                  [config]="{ label: 'Apellidos y nombre de la persona con quien relacionarse' }"></app-ui-input>
                <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'contactoNombre' }"></ng-container>
              </div>
            </div>
          </div>
          <div class="m193-card__foot">
            <button mat-stroked-button class="cf-btn" (click)="confirmarRegion('declarante')">
              <mat-icon>check</mat-icon> Declarante confirmado
            </button>
          </div>
        </div>

        <div class="m193-card" id="region-declaracion" [class.m193-card--collapsed]="colapsada('declaracion')">
          <div class="m193-card__head" (click)="toggleRegion('declaracion')">
            <mat-icon>description</mat-icon>
            <span class="m193-card__head-label">2 - Declaración</span>
            <mat-icon class="m193-card__check" *ngIf="confirmada('declaracion')">check_circle</mat-icon>
            <mat-icon class="m193-card__chevron">{{ colapsada('declaracion') ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
          </div>
          <div class="m193-card__body">
            <div class="m193-fields">
              <div class="m193-field m193-field--4" [class.cf-field--invalid]="!!mensaje('complementaria')">
                <app-select id="complementaria" name="tipoDeclaracion" [ngModel]="tipoDeclaracion"
                  (ngModelChange)="onTipoDeclaracion($event)"
                  [config]="{ label: 'Tipo de declaración', options: tipoDeclaracionOptions }"></app-select>
                <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'complementaria' }"></ng-container>
              </div>
              <div class="m193-field m193-field--4 cf-field--required" *ngIf="pideJustificante"
                [class.cf-field--invalid]="!!mensaje('justificante')">
                <app-ui-input id="justificante" name="justificante" [ngModel]="data.justificante"
                  (ngModelChange)="onJustificante($event)"
                  [config]="{ label: 'Nº identificativo de la declaración anterior', maxLength: 13 }"></app-ui-input>
                <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'justificante' }"></ng-container>
              </div>
              <div class="m193-field m193-field--4" [class.cf-field--invalid]="!!mensaje('numeroIdentificativo')">
                <app-ui-input id="numeroIdentificativo" name="numeroIdentificativo"
                  [(ngModel)]="data.numeroIdentificativo"
                  [config]="{ label: 'Nº identificativo', maxLength: 13 }"></app-ui-input>
                <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'numeroIdentificativo' }"></ng-container>
              </div>
              <div class="m193-field m193-field--4">
                <app-select id="naturalezaDeclarante" name="naturalezaDeclarante" [ngModel]="naturalezaDeclaranteValor"
                  (ngModelChange)="onNaturalezaDeclarante($event)"
                  [config]="{ label: 'Naturaleza del declarante (S)', options: sinoOptions }"></app-select>
              </div>
            </div>
          </div>
          <div class="m193-card__foot">
            <button mat-stroked-button class="cf-btn" (click)="confirmarRegion('declaracion')">
              <mat-icon>check</mat-icon> Declaración confirmada
            </button>
          </div>
        </div>

        <div class="m193-card" id="region-resumen" [class.m193-card--collapsed]="colapsada('resumen')">
          <div class="m193-card__head" (click)="toggleRegion('resumen')">
            <mat-icon>functions</mat-icon>
            <span class="m193-card__head-label">3 - Resumen de totales</span>
            <mat-icon class="m193-card__check" *ngIf="confirmada('resumen')">check_circle</mat-icon>
            <mat-icon class="m193-card__chevron">{{ colapsada('resumen') ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
          </div>
          <div class="m193-card__body">
            <ng-container *ngTemplateOutlet="totalFila; context: { etiqueta: 'Número total de perceptores', campo: 'numeroPerceptores', valor: data.numeroPerceptores, dinero: false }"></ng-container>
            <ng-container *ngTemplateOutlet="totalFila; context: { etiqueta: 'Base de las retenciones e ingresos a cuenta', campo: 'totalBase', valor: data.totalBase, dinero: true }"></ng-container>
            <ng-container *ngTemplateOutlet="totalFila; context: { etiqueta: 'Total retenciones e ingresos a cuenta', campo: 'totalRetenciones', valor: data.totalRetenciones, dinero: true }"></ng-container>
            <ng-container *ngTemplateOutlet="totalFila; context: { etiqueta: 'Retenciones e ingresos a cuenta ingresados', campo: 'retencionesIngresadas', valor: data.retencionesIngresadas, dinero: true }"></ng-container>
          </div>
          <div class="m193-card__foot">
            <button mat-stroked-button class="cf-btn" (click)="confirmarRegion('resumen')">
              <mat-icon>check</mat-icon> Resumen confirmado
            </button>
          </div>
        </div>

        <div class="m193-card" id="region-perceptores" [class.m193-card--collapsed]="colapsada('perceptores')">
          <div class="m193-card__head" (click)="toggleRegion('perceptores')">
            <mat-icon>groups</mat-icon>
            <span class="m193-card__head-label">4 - Perceptores</span>
            <mat-icon class="m193-card__check" *ngIf="confirmada('perceptores')">check_circle</mat-icon>
            <mat-icon class="m193-card__chevron">{{ colapsada('perceptores') ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
          </div>
          <div class="m193-card__body" id="perceptores">
            <ng-container *ngTemplateOutlet="errorCampo; context: { clave: 'perceptores' }"></ng-container>
            <app-model-193-recipients [ejercicio]="ejercicio" [declarante]="data" [version]="version"
              [validations]="validations" [foco]="foco"
              (changed)="onPerceptoresCambiados()"></app-model-193-recipients>
          </div>
          <div class="m193-card__foot">
            <button mat-stroked-button class="cf-btn" (click)="confirmarRegion('perceptores')">
              <mat-icon>check</mat-icon> Perceptores confirmados
            </button>
          </div>
        </div>

        <div class="m193-card" id="region-presentacion" [class.m193-card--collapsed]="colapsada('presentacion')">
          <div class="m193-card__head" (click)="toggleRegion('presentacion')">
            <mat-icon>task_alt</mat-icon>
            <span class="m193-card__head-label">5 - Presentación</span>
            <mat-icon class="m193-card__check" *ngIf="confirmada('presentacion')">check_circle</mat-icon>
            <mat-icon class="m193-card__chevron">{{ colapsada('presentacion') ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
          </div>
          <div class="m193-card__body">
            <div class="m193-alerts" *ngIf="data.avisos.length">
              <div class="m193-alert m193-alert--warning" *ngFor="let aviso of data.avisos; trackBy: trackByIndex">
                <mat-icon>warning</mat-icon>
                <span class="m193-alert__text">{{ aviso }}</span>
              </div>
            </div>

            <div class="m193-guia" *ngIf="mostrarGuia">
              <div class="m193-guia__head">
                <mat-icon>task_alt</mat-icon>
                <span>Ya tienes el fichero <strong>{{ nombreFichero }}</strong>. Para presentarlo:</span>
                <button type="button" class="m193-guia__close" (click)="mostrarGuia = false">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
              <ol class="m193-guia__pasos">
                <li>Entra en la sede electrónica de la Agencia Tributaria con tu certificado.</li>
                <li>Elige el modelo 193 y la opción de importar un fichero.</li>
                <li>Selecciona el fichero descargado.</li>
                <li>Revisa, firma y presenta. Luego vuelve aquí y márcala como presentada.</li>
              </ol>
            </div>

            <div class="m193-presentar">
              <button mat-stroked-button class="cf-btn" (click)="validate()">
                <mat-icon>search</mat-icon> Validar
              </button>
              <button mat-stroked-button class="cf-btn cf-btn--primary" (click)="getFile()">
                <mat-icon>file_download</mat-icon> Descargar fichero
              </button>
              <button mat-stroked-button class="cf-btn" *ngIf="path" (click)="redirectFileTax()">
                <mat-icon>open_in_new</mat-icon> Presentar en la sede
              </button>
              <button mat-stroked-button class="cf-btn" (click)="marcarPresentada()" [disabled]="!declaracionActual">
                <mat-icon>check_circle</mat-icon> Marcar como presentada
              </button>
            </div>
          </div>
          <div class="m193-card__foot">
            <button mat-stroked-button class="cf-btn" (click)="confirmarRegion('presentacion')">
              <mat-icon>check</mat-icon> Presentación confirmada
            </button>
          </div>
        </div>

      </div>
    </div>

  </ng-container>
</div>
